import { createRouter as createTanstackRouter } from '@tanstack/react-router';
import {dehydrate, hydrate, QueryClient} from '@tanstack/react-query';
import { routeTree} from '@/routeTree.gen';
import NotFound from '@/notFound.tsx';

export function createRouter(isLoggedIn: boolean = false, isServer: boolean = false) {
  const queryClient = new QueryClient();
  return createTanstackRouter({
    defaultNotFoundComponent: NotFound,
    routeTree,
    context: {
      isLoggedIn,
      queryClient,
      isServer,
    },
    dehydrate: () => {
      return {
        queryClientState: dehydrate(queryClient),
      }
    },
    hydrate: (dehydrated) => {
      hydrate(queryClient, dehydrated.queryClientState);
    },
    defaultPendingMinMs: 1000,
    defaultPendingMs: 1000,
    defaultPreloadStaleTime: 0,
    defaultPreload: 'intent',
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
